import Image from '@/atoms/Image/Image';
import RibbonLabel from '@/atoms/RibbonLabel/RibbonLabel';
import useLocalizedUrl from '@/hooks/use-localized-url/use-localized-url';
import FollowButton from '@/molecules/Buttons/Follow/FollowButton';
import Link from 'next/link';
import {
  FALLBACK_WIDTH,
  PRODUCT_CARD_SIZES,
  productCardImageSrcSetDef,
} from '../../../../services/image-loader';
import {
  StyledArtistCard,
  StyledArtistCountry,
  StyledArtistInfo,
  StyledArtistName,
  StyledImgGrid,
  StyledRating,
} from './styles';
import {Props} from './typings';

const ArtistCard = ({artist, followBtn, hardNavigation = false, link, onClick}: Props) => {
  const artistHref = link ?? `/artist/${artist.slug}/`;
  const getLocalizedUrl = useLocalizedUrl();

  return (
    <StyledArtistCard>
      {!!artist.sale_discount_amount && (
        <RibbonLabel>{`Sale - save ${artist.sale_discount_amount}%`}</RibbonLabel>
      )}
      {hardNavigation ? (
        <a href={getLocalizedUrl(artistHref)} aria-label={artist.name} onClick={onClick} />
      ) : (
        <Link href={artistHref} aria-label={artist.name} onClick={onClick} />
      )}

      <StyledImgGrid>
        {artist.images.slice(0, 3).map((image, i) => (
          <Image
            alt={`Artwork by ${artist.name}`}
            path={image.path}
            srcSetDef={productCardImageSrcSetDef(image.path)}
            sizes={PRODUCT_CARD_SIZES}
            fallbackWidth={FALLBACK_WIDTH}
            width={i === 0 ? 268 : 133}
            height={134}
            key={i}
            responsive
            retina
          />
        ))}
      </StyledImgGrid>

      <StyledArtistInfo>
        <Image path={artist.avatar_url} alt={artist.name} width={64} height={64} retina />

        <StyledArtistName>{artist.name}</StyledArtistName>

        <StyledArtistCountry>{artist.country}</StyledArtistCountry>

        {followBtn ? (
          <FollowButton
            artistId={artist.id}
            artistSlug={artist.slug}
            artistName={artist.name}
            type="small"
          />
        ) : (
          !!artist.seller_rating && <StyledRating value={artist.seller_rating} size={16} />
        )}
      </StyledArtistInfo>
    </StyledArtistCard>
  );
};

export default ArtistCard;
